import { render, staticRenderFns } from "./FolderPermissions.vue?vue&type=template&id=0d2b1eae&scoped=true&"
import script from "./FolderPermissions.vue?vue&type=script&lang=ts&"
export * from "./FolderPermissions.vue?vue&type=script&lang=ts&"
import style0 from "./FolderPermissions.vue?vue&type=style&index=0&id=0d2b1eae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d2b1eae",
  null
  
)

export default component.exports